/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_BedroomsInputs */

const en_field_bedrooms = /** @type {(inputs: Field_BedroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedrooms`)
};

const es_field_bedrooms = /** @type {(inputs: Field_BedroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dormitorios`)
};

const fr_field_bedrooms = /** @type {(inputs: Field_BedroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chambres`)
};

const de_field_bedrooms = /** @type {(inputs: Field_BedroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlafzimmer`)
};

const ja_field_bedrooms = /** @type {(inputs: Field_BedroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ベッドルーム数`)
};

const zh_field_bedrooms = /** @type {(inputs: Field_BedroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`卧室`)
};

const ar_field_bedrooms = /** @type {(inputs: Field_BedroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`غرف النوم`)
};

const id_field_bedrooms = /** @type {(inputs: Field_BedroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamar Tidur`)
};

const it_field_bedrooms = /** @type {(inputs: Field_BedroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camere da Letto`)
};

const ru_field_bedrooms = /** @type {(inputs: Field_BedroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спальни`)
};

const pt_field_bedrooms = /** @type {(inputs: Field_BedroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quartos`)
};

const ko_field_bedrooms = /** @type {(inputs: Field_BedroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`침실`)
};

/**
* | output |
* | --- |
* | "Bedrooms" |
*
* @param {Field_BedroomsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_bedrooms = /** @type {((inputs?: Field_BedroomsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_BedroomsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_bedrooms(inputs)
	if (locale === "es") return es_field_bedrooms(inputs)
	if (locale === "fr") return fr_field_bedrooms(inputs)
	if (locale === "de") return de_field_bedrooms(inputs)
	if (locale === "ja") return ja_field_bedrooms(inputs)
	if (locale === "zh") return zh_field_bedrooms(inputs)
	if (locale === "ar") return ar_field_bedrooms(inputs)
	if (locale === "id") return id_field_bedrooms(inputs)
	if (locale === "it") return it_field_bedrooms(inputs)
	if (locale === "ru") return ru_field_bedrooms(inputs)
	if (locale === "pt") return pt_field_bedrooms(inputs)
	return ko_field_bedrooms(inputs)
});